export const checkIpfsUrl = async (url: string): Promise<boolean> => {
  const MAX_RETRIES = 60;
  const INTERVAL_MS = 5000;

  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      const response = await fetch(url, { signal: controller.signal });
      clearTimeout(timeoutId);

      if (response.ok) {
        return true;
      }

      await new Promise(resolve => setTimeout(resolve, INTERVAL_MS));
    } catch (error) {
      await new Promise(resolve => setTimeout(resolve, INTERVAL_MS));
    }
  }

  return false;
};
